class Auth {
  constructor() {}

  fetchKey() {
    return fetch('/auth/')
      .then((resp) => resp.json())
      .then((result) => {
        const res = result as AuthResponse

        this.saveToken(res.token)
        console.log(res.token)

        return res.token
      })
  }

  saveToken(token: string) {
    sessionStorage.setItem('bw-api-token', token)
  }

  async getToken(): Promise<string> {
    // const token = sessionStorage.getItem('bw-api-token');
    // if (token) {
    // 	// Promise.resolve(token);
    // 	return token;
    // } else {
    return await this.fetchKey()
    // }
  }
}

export type AuthResponse = {
  token: string
  expire: string
}

export default new Auth()
